import React from "react";
import { AppProvider } from "./src/context";
import GTM from '@src/utils/GTM.js';

export const onRouteUpdate = () => {
	GTM.handleRoute();
}

export const wrapRootElement = ({ element }) => (
    <AppProvider>{element}</AppProvider>
)

export const onClientEntry = () => {
  if (!document.getElementById('brightcove-player-script')) {
    const script = document.createElement('script');
    script.id = 'brightcove-player-script';
    script.src = `//players.brightcove.net/4317630935001/JLmFQmE87_default/index.min.js`;
    script.async = true;
    document.body.appendChild(script);
  }
};